var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHotel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.44536 12.4905C9.40127 12.4905 10.9908 10.8546 10.9908 8.84162C10.9908 6.82866 9.40127 5.19275 7.44536 5.19275C5.48945 5.19275 3.8999 6.82866 3.8999 8.84162C3.8999 10.8546 5.48945 12.4905 7.44536 12.4905Z",
    fill: "#0A6ADA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8182 5.27877H19.2727C21.8845 5.27877 24 7.45593 24 10.1439V20.8988C24 21.6345 23.4036 22.2308 22.668 22.2308H22.032C21.2964 22.2308 20.7 21.6344 20.7 20.8988V17.4417H3.1V20.8988C3.1 21.6345 2.50364 22.2308 1.768 22.2308H1.332C0.596357 22.2308 0 21.6345 0 20.8988V4.02801C0 3.37531 0.529118 2.84619 1.18182 2.84619C1.83452 2.84619 2.36364 3.37531 2.36364 4.02801V13.7928H11.8182V5.27877ZM10.6364 7.78739C10.6364 9.80035 9.04683 11.4363 7.09092 11.4363C5.13501 11.4363 3.54546 9.80035 3.54546 7.78739C3.54546 5.77443 5.13501 4.13852 7.09092 4.13852C9.04683 4.13852 10.6364 5.77443 10.6364 7.78739Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/Hotel.42120a7c94438c8c87f006a9a1857e32.svg";
export { ForwardRef as ReactComponent };